<template>
  <div class="common-layout">
    <el-container>
      <div
        class="left-menu"
        :class="{
          open: toggleMenu,
        }"
      >
        <img
          src="@/assets/logo.svg"
          class="menu__logo"
          alt=""
          srcset=""
          @click="$router.push('/profile')"
        />

        <UserName />
        <el-divider />

        <!-- <el-scrollbar> -->
        <LeftMenu />
        <!-- </el-scrollbar> -->
      </div>
      <div class="overlay" v-if="toggleMenu" @click="toggleMenu = false"></div>

      <router-view @openMenu="toggleMenu = true" />
    </el-container>
  </div>
</template>

<script>
import LeftMenu from "@/layout/components/LeftMenu";
import UserName from "@/components/Common/UserName.vue";
import { mapActions } from "vuex";
import ApiAuth from "@/api/auth";
export default {
  data() {
    return {
      toggleMenu: false,
    };
  },
  watch: {
    $route(to, from) {
      this.toggleMenu = false;
    },
  },
  components: {
    UserName,
    LeftMenu,
  },
  methods: {
    ...mapActions("User", ["setUser", "getGroupList"]),
  },
  mounted() {
    ApiAuth.getMe().then((responce) => {
      this.setUser(responce.data);
    });
    this.getGroupList();
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped>
.menu__logo {
  width: 90%;
  display: block;
  margin: 15px auto;
}

@media only screen and (max-width: 768px) {
  .menu__logo {
    width: 70%;
  }
}
</style>